import { render, staticRenderFns } from "./ProductCardIcons.vue?vue&type=template&id=5e650ff0&"
import script from "./ProductCardIcons.vue?vue&type=script&lang=js&"
export * from "./ProductCardIcons.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardIcons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports